import { dataShieldEllipsisSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldEllipsisSolid = /*#__PURE__*/createIcon(dataShieldEllipsisSolid)
export default IconShieldEllipsisSolid
